import { LlmModel } from '@/libs/features/llm/types'
import { splitTitleCaseWithSpaces } from '../../string/string'

/* Quick heuristic of cost in dollar signs for each model based on its actual pricing above.
   This is based on non-scientific cost ranges (below).

   Price per 1000 input + 1000 output tokens
                          input   output  total
   $$$$
   - Claude 4.5 sonnet	  $0.0033	$0.0165	$0.0180
   $$$
   - Claude 4.5 haiku     $0.0010 $0.0050 $0.0060
   - Nova pro	            $0.0008	$0.0032	$0.0040
   $$
   - Llama 3.3	          $0.0007	$0.0007	$0.0014
   $
   - Nova lite	          $0.0001	$0.0002	$0.0003
   - Nova micro	          $0.0000	$0.0001	$0.0002
   */
const MODEL_TO_DOLLAR_SIGNS: Record<LlmModel, number> = {
  [LlmModel.CLAUDE_SONNET_4_5]: 4,
  [LlmModel.CLAUDE_SONNET_4]: 4,
  [LlmModel.AMAZON_NOVA_PRO]: 3,
  [LlmModel.CLAUDE_HAIKU_4_5]: 3,
  [LlmModel.LLAMA_3_3]: 2,
  [LlmModel.AMAZON_NOVA_LITE]: 1,
  [LlmModel.AMAZON_NOVA_MICRO]: 1,
}

/*
 * Converts a model name to a more readable format with spaces and dollar signs.
 * For example, "AMAZON_NOVA_LITE" becomes "Amazon Nova Lite ($)".
 * @param model The LlmModel enum value to convert.
 * @returns A string representing the model in a readable format.
 */
export const readableModel = (model: LlmModel) => {
  // Replace underscores between numbers with a dot, e.g. "Something 3_5" -> "Something 3.5"
  const readableModel = splitTitleCaseWithSpaces(
    model.toLowerCase()
  ).replaceAll(/(\d) (\d)/g, '$1.$2')
  const cost = MODEL_TO_DOLLAR_SIGNS[model]
  return cost ? `${readableModel} (${'$'.repeat(cost)})` : ''
}

/*
 * Generates an array of options for a dropdown menu, where each option
 * contains a label and value for each LLM model.
 */
export const llmModelDropdownOptions = Object.values(LlmModel).map((model) => ({
  label: readableModel(model),
  value: model,
}))
